import * as actionTypes from './actionTypes';
import * as actions from './actions';
import * as typings from './typings';

export const confirmModalActionTypes = actionTypes;
export const confirmModalActions = actions;
export const confirmModalTypings = typings;
